export enum ExportRestrictStatusType {
    NotStarted = 0,
    Received = 1,
    InProgress = 2,
    Completed = 3,
    Expired = 4,
    Error = 5,
}

export enum RequestType {
    None = 0,
    Export = 1,
    Restrict = 2,
    Delete = 3,
}